export enum RequirementsModalModeEnum {
  'SELECT_NPA',
  'SELECT_STRUCTURAL_UNIT',
  'SELECT_MANDATORY',
  'CREATE_NPA',
  'EDIT_NPA',
  'CREATE_STRUCTURAL_UNIT',
}
